<template>
  <div class="animated fadeIn">
    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <div slot="header">
        <i class="icon-note"></i> Order Detail
      </div>

      <b-card-body>
        <div>
          <b-form id="employeeForm" validated novalidate>
            <div v-if="loading == true">
              <loading></loading>
            </div>

            <div v-if="loading == false">
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="order_number" label="Order Number">
                    <b-form-input
                      id="order_number"
                      type="text"
                      v-model="orderForm.order_number"
                      readonly
                    ></b-form-input>
                    <b-form-invalid-feedback>Order Number harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="customer" label="Customer">
                        <vue-autosuggest
                          v-model="customers.text"
                          @inputout="focusMe"
                          :suggestions="filteredOptions"
                          @input="onInputChange"
                          @selected="onSelected"
                          :input-props="{ id: 'customer', placeholder: 'Find Customer', class: 'form-control'}"
                          :limit="20"
                        >
                          <template slot-scope="{ suggestion }">
                            <span class="my-suggestion-item"> 
                              {{ suggestion.item.text }}
                            </span>
                          </template>
                        </vue-autosuggest>
                    </b-form-group>
                  <!-- <b-form-group label-for="customer_id" label="Konsumen">
                    <model-select
                      :options="listCustomer"
                      v-model="$v.orderForm.customer_id.$model"
                      :isError="$v.orderForm.customer_id.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="orderForm.customer_id === null"
                      class="invalid-feedback-custom"
                    >Konsumen harus di isi.</div>
                  </b-form-group> -->
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="plan_delivery_order" label="Tanggal Pengiriman">
                    <v-date-picker
                      id="plan_delivery_order"
                      :input-props="{ class: 'form-control', placeholder: 'Tanggal Pengiriman', required: ''}"
                      :state="!$v.orderForm.plan_delivery_order.$invalid"
                      v-model="$v.orderForm.plan_delivery_order.$model"
                    ></v-date-picker>
                    <div
                      v-if="$v.orderForm.plan_delivery_order.$invalid"
                      class="invalid-feedback-custom"
                    >Tanggal pengiriman harus di isi.</div>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="order_type" label="Jenis Order">
                    <model-select
                      id="order_type"
                      :options="listOrderType"
                      v-model="$v.orderForm.order_type.$model"
                      :isError="$v.orderForm.order_type.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="orderForm.order_type === null"
                      class="invalid-feedback-custom"
                    >Jenis order harus di isi.</div>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b-form-group label-for="description" label="Deskripsi">
                    <b-form-textarea
                      id="description"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.orderForm.description.$model"
                      :state="!$v.orderForm.description.$invalid"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Deskripsi harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <div slot="footer" class="text-right">
                <b-button type="button" size="sm" variant="danger" @click="back">
                  <i class="fa fa-undo"></i> Back
                </b-button>&nbsp;
                <b-button
                  v-if="allowEdit"
                  type="button"
                  size="sm"
                  variant="primary"
                  @click="editOrder"
                  :disabled="$v.orderForm.$invalid"
                >
                  <i class="fa fa-save"></i> Save
                </b-button>
              </div>
            </div>
          </b-form>
        </div>
      </b-card-body>
    </b-card>

    <b-card>
      <b-card-body>
        <b-row v-if="loading == false">
          <b-col sm="12">
            <global-table
              :table-data="orderDetail"
              :loading="loading"
              :per-page="10"
              :table-detail="tableDetail"
              :bordered="true"
              :hover="true"
              :striped="false"
              :id-modals="'orderDetailForm'"
              :row-edit="orderDetailForm"
              :redirect-detail="false"
              :show-add-button="allowAdd"
              :remove-button="allowRemove"
              :edit-button="allowEdit"
              :fields="fieldsOrderDetail"
              addButton="Detail Produk"
              @editForm="editForm"
              @resetForm="resetForm"
              @removeForm="removeForm"
            ></global-table>

            <b-modal
              ref="myModalDetailRef"
              id="orderDetailForm"
              header-border-variant="no-border text-center"
              footer-border-variant="no-border"
              footer-bg-variant="light"
              :no-close-on-backdrop="true"
              :no-close-on-esc="true"
              size="lg"
            >
              <div slot="modal-header" class="text-center">
                <h3 class="text-center">Form Order Detail</h3>
              </div>
              <div v-if="!loadingAddDetail">
                <b-form id="orderDetailForm" validated novalidate>
                  <b-row>
                    <b-col sm="4">
                      <b-form-group label-for="product_id" label="Produk">
                        <model-select
                          id="product_id"
                          :options="listProduct"
                          v-model="$v.orderDetailForm.product_id.$model"
                          :isError="$v.orderDetailForm.product_id.$invalid"
                          placeholder="-- Harap pilih salah satu --"
                        ></model-select>
                        <div
                          v-if="orderDetailForm.product_id === null"
                          class="invalid-feedback-custom"
                        >Produk harus di isi.</div>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group label-for="qty_plan" label="Total Pesanan Dalam Box">
                        <b-form-input
                          id="qty_plan"
                          type="number"
                          v-model="$v.orderDetailForm.qty_plan.$model"
                          :state="!$v.orderDetailForm.qty_plan.$invalid"
                          required
                          placeholder="Total Pesanan"
                        ></b-form-input>
                        <b-form-invalid-feedback>Total Pesanan harus di isi.</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                    <!-- <b-col sm="3">
                      <b-form-group label-for="qty_actual" label="Total Aktual">
                        <b-form-input
                          id="qty_actual"
                          type="number"
                          v-model="$v.orderDetailForm.qty_actual.$model"
                          placeholder="Total Aktual"
                        ></b-form-input>
                        <b-form-invalid-feedback>Total Aktual harus di isi.</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col> -->
                  </b-row>
                </b-form>
              </div>
              <div v-else>  
                <loading></loading>
              </div>

              <div slot="modal-footer" class="float-right">
                <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                  <i class="fa fa-undo"></i> Back
                </b-button>&nbsp;
                <b-button
                  type="button"
                  size="sm"
                  variant="primary"
                  @click="submitAdd"
                  :disabled="$v.orderDetailForm.$invalid"
                >
                  <i class="fa fa-save"></i> Save
                </b-button>
              </div>
            </b-modal>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col sm="12">
            <loading></loading>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import globalTable from "../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import axios from "axios";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import loading from "@/templates/Loading.vue";
import "moment/locale/id";
import { VueAutosuggest } from 'vue-autosuggest';

export default {
  name: "orderDetail",
  components: { globalTable, ModelSelect, loading, VueAutosuggest },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: true,
      loadingAddDetail: false,
      removeButton: true,
      orderForm: interfaces.order,
      listCustomer: [],
      listPricingUnit: [],
      listProduct: [],
      orderDetailForm: interfaces.order_detail,
      orderDetail: [],
      listOrderType: [],
      fieldsOrderDetail: [
        { key: "product_name", label: "Nama Produk" },
        { key: "qty_plan", label: "Qty Plan" },
        { key: "price_plan", label: "Price Plan" },
        { key: "total_price_plan", label: "Total Price Plan" },
        { key: "action", class: "text-center width-100" }
      ],
      items: [],
      lastSelectItem: {},
      customers: {
        text: null,
        value: null
      },
      filteredOptions: [],
      suggestions: [
        {
          data: [],
        },
      ],
    };
  },
  computed: {
     allowAdd() {
      let nik = localStorage.getItem("nik");
      return (['MBS19080016', 'MBS24060005', 'MBS25070002', 'MBS25020005', 'MBS23070002'].includes(nik)) ? true: false;
    },
    allowEdit() {
      let nik = localStorage.getItem("nik");
      return (['MBS19080016'].includes(nik)) ? true: false;
    },
    allowRemove() {
      let nik = localStorage.getItem("nik");
      return (['MBS19080016'].includes(nik)) ? true: false;
    }
  },
  validations: {
    orderForm: {
      customer_id: { required },
      plan_delivery_order: { required },
      description: {},
      order_type: {required}
    },
    orderDetailForm: {
      product_id: { required },
      qty_plan: { required },
      qty_actual: {}
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function(order_id) {
      this.loading = true;
      this.getDetailData(order_id);
      this.getDropdown(order_id);
    },
    getDropdown: function(order_id) {
      this.axios
        .get("web/dropdown/dropdown-order-detail/"+order_id+"/")
        .then(response => {
          this.listCustomer = response.data.customer;
          this.listPricingUnit = response.data.pricing_unit;
          this.listProduct = response.data.product;
          this.listOrderType = response.data.order_type;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getDetailData: function(id) {
      this.axios
        .get("web/order/detail/" + id + "/")
        .then(response => {
          this.orderForm = response.data.order;
          this.orderForm.plan_delivery_order = (this.orderForm.plan_delivery_order !== null) ? new Date(this.orderForm.plan_delivery_order) : null;
          this.customers.text = this.orderForm.customer_name;
          this.customers.value = this.orderForm.customer_id;
          this.orderDetail = response.data.order_detail;
          if (this.orderForm.status === "1") {
            this.removeButton = false;
          }
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function(a) {
      this.resetForm();
      this.orderDetailForm = a;
      this.orderDetailForm.isEdit = 1;
    },
    removeForm: function(data) {
      let route = this.$route.path.split("/");
      if (confirm("Apakah anda ingin menghapus order ini ?")) {
        this.axios
          .delete("web/order/remove-detail/" + data.id)
          .then(response => {
            let _detailData = response.data.data;
            this.showInfoNotification({
              title: "Hapus Detail Order",
              message: response.data.message
            });
            this.init(route[4]);
          })
          .catch(error => {
            if (error.response.status === 401) {
              localStorage.clear();
              this.$router.push({ path: "/login" });
              this.showErrorNotification({
                title: "Token Expired",
                message: "Your session has been expired"
              });
            } else {
              this.showErrorNotification({
                title: "Add Order",
                message: error.response.data.message
              });
            }
          });
      }
    },
    resetForm: function() {
      for (var a in interfaces.order_detail) {
        interfaces.order_detail[a] = null;
      }
      this.orderDetailForm = interfaces.order_detail;
    },
    cancelAdd: function() {
      this.$refs.myModalDetailRef.hide();
    },
    handleSubmit: function() {
      this.$refs.myModalDetailRef.hide();
    },
    back: function() {
      this.$router.go(-1);
    },
    editOrder: function(evt) {
      evt.preventDefault();
      this.loading = true;
      if (confirm("Apakah anda ingin mengubah order ?")) {
        this.axios
          .put("web/order/change-order/", this.orderForm)
          .then(response => {
            let _detailData = response.data.data;
            this.showInfoNotification({
              title: "Add Order",
              message: response.data.message
            });
          })
          .catch(error => {
            if (error.response.status === 401) {
              localStorage.clear();
              this.$router.push({ path: "/login" });
              this.showErrorNotification({
                title: "Token Expired",
                message: "Your session has been expired"
              });
            } else {
              this.showErrorNotification({
                title: "Add Order",
                message: error.response.data.message
              });
            }
          })
          .finally(() => {
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    submitAdd: function(evt) {
      evt.preventDefault();
      let orderDetail = this.orderDetailForm;
      let route = this.$route.path.split("/");
      orderDetail.order_id = route[4];
      orderDetail.customer_id = this.orderForm.customer_id;
      orderDetail.pricing_unit_id = this.orderForm.pricing_unit_id;
      orderDetail.order_type = this.orderForm.order_type;
      this.loadingAddDetail = true;
      if (this.orderDetailForm.id === undefined) {
        if (confirm("Apakah anda ingin menambahkan order detail ?")) {
          this.axios
            .post("web/order/add-detail/", orderDetail)
            .then(response => {
              if (response.data.status === 2000) {
                let _detailData = response.data.data;
                this.showInfoNotification({
                  title: "Berhasil tambah order",
                  message: response.data.message
                });
              } else {
                this.showErrorNotification({
                  title: "Gagal tambah order",
                  message: response.data.message
                });
              }
              this.handleSubmit();
            })
            .catch(error => {
              if (error.response.status === 401) {
                localStorage.clear();
                this.$router.push({ path: "/login" });
                this.showErrorNotification({
                  title: "Token Expired",
                  message: "Your session has been expired"
                });
              } else {
                this.showErrorNotification({
                  title: "Add Order",
                  message: error.response.data.message
                });
              }
            })
            .finally(() => {
              this.loadingAddDetail = false;
              this.init(route[4]);
            });
        }
      } else if (this.orderDetailForm.id !== undefined) {
        if (confirm("Apakah anda ingin mengubah order ini ?")) {
          this.axios
            .put("web/order/change-add-detail/", orderDetail)
            .then(response => {
              if (response.data.status === 2000) {
                let _detailData = response.data.data;
                this.showInfoNotification({
                  title: "Add Order",
                  message: response.data.message
                });
              } else {
                this.showInfoNotification({
                  title: "Add Order",
                  message: response.data.message
                });
              }
              this.handleSubmit();
            })
            .catch(error => {
              if (error.response.status === 401) {
                localStorage.clear();
                this.$router.push({ path: "/login" });
                this.showErrorNotification({
                  title: "Token Expired",
                  message: "Your session has been expired"
                });
              } else {
                this.showErrorNotification({
                  title: "Add Order",
                  message: error.response.data.message
                });
              }
            })
            .finally(() => {
              this.loadingAddDetail = false;
              this.getDetailData(route[4]);
            });
        }
      }
    },
    onSelected(item) {
      console.log(item);
      if (item === "" || item === undefined || item === null) {
        this.orderForm.customer_id = null
        this.customers.text = null;
        this.customers.value = null;
        return;
      } else {
        this.orderForm.customer_id = item.item.value;
        this.customers.text = item.item.text;
        this.customers.value = item.item.value;
     }
    },
    focusMe: function(item){
       if (item === "" || item === undefined || item === null) {
        this.customers.value = null;
        this.customers.text = null;
        this.orderForm.customer_id = null;
        return;
      }
    },
    onInputChange(text) {
      if (text === "" || text === undefined || text === null) {
        this.customers.value = null;
        this.customers.text = null;
        return;
      } else {
        axios
          .post("web/dropdown/find-customer/", {'name':text})
          .then((response) => {
            this.dropdown_customer = response.data.data;
            this.suggestions[0].data = this.dropdown_customer;
            const filteredData = this.suggestions[0].data;
            this.filteredOptions = [
              {
                data: filteredData,
              },
            ];
          })
          .catch((error) => {})
          .finally(() => {});
      }
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  }
};
</script>